module.exports = __webpack_public_path__ + "static/media/person03.7dd61195.mp4";